(function () {
  'use strict';

  // subscribe-form may also load this asset — avoid duplicate listeners
  if (window.__cmsModalSectionLoaded) return;
  window.__cmsModalSectionLoaded = true;

  function normalizeModalId(id) {
    if (!id) return '';
    return String(id)
      .trim()
      .replace(/^shopify-block-/, '')
      .replace(/^cms-modal-/, '');
  }

  function openModal(id) {
    const modal = resolveModal(id);
    if (!modal) return false;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const closeBtn = modal.querySelector('.cms-modal-close, .cms-popup__close');
    if (closeBtn) closeBtn.focus();
    return true;
  }

  function closeModal(id) {
    const modal = resolveModal(id);
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function closeAllModals() {
    document.querySelectorAll('.cms-modal-overlay.is-open').forEach(function (modal) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
    });
    document.body.style.overflow = '';
  }

  function parseCmsIds(raw) {
    return String(raw || '')
      .split(',')
      .map(normalizeModalId)
      .filter(Boolean);
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    return String(value).replace(/([^\w-])/g, '\\$1');
  }

  /** Resolve shopify-block / data-cms-block-id; tolerate partial / suffix ids from theme editor */
  function resolveShopifyBlock(id) {
    const blockId = normalizeModalId(id);
    if (!blockId) return null;

    var el = document.getElementById('shopify-block-' + blockId);
    if (el) return el;

    var panel = document.querySelector('[data-cms-block-id="' + cssEscape(blockId) + '"]');
    if (panel) {
      el = panel.closest('[id^="shopify-block-"]') || panel.closest('.shopify-block') || panel;
      if (el) return el;
    }

    el = document.querySelector('[id="shopify-block-' + cssEscape(blockId) + '"]');
    if (el) return el;

    // Suffix / key match: cms_card_item_xxx or hash__cms_card_item_xxx
    var suffix = blockId;
    var sep = blockId.lastIndexOf('__');
    if (sep >= 0) suffix = blockId.slice(sep + 2);
    if (suffix) {
      el = document.querySelector('[id^="shopify-block-"][id$="' + cssEscape(suffix) + '"]');
      if (el) return el;
      el = document.querySelector('[id^="shopify-block-"][id*="__' + cssEscape(suffix) + '"]');
      if (el) return el;
      panel = document.querySelector('[data-cms-block-id$="' + cssEscape(suffix) + '"]');
      if (panel) {
        el = panel.closest('[id^="shopify-block-"]') || panel.closest('.shopify-block');
        if (el) return el;
      }
    }

    return null;
  }

  function resolveModal(id) {
    const modalId = normalizeModalId(id);
    if (!modalId) return null;
    var modal = document.getElementById('cms-modal-' + modalId);
    if (modal) return modal;
    // Suffix match for pasted partial ids
    var suffix = modalId;
    var sep = modalId.lastIndexOf('__');
    if (sep >= 0) suffix = modalId.slice(sep + 2);
    if (suffix) {
      modal = document.querySelector('[id^="cms-modal-"][id$="' + cssEscape(suffix) + '"]');
      if (modal) return modal;
    }
    return null;
  }

  function isModalOpen(modal) {
    return !!(modal && modal.classList.contains('is-open'));
  }

  function toggleModal(id) {
    const modal = resolveModal(id);
    if (!modal) return false;
    if (isModalOpen(modal)) {
      closeModal(normalizeModalId(modal.id));
    } else {
      openModal(id);
    }
    return true;
  }

  /** Find the [data-hide] node for a block.id (panel or self) */
  function resolveHideEls(id) {
    const block = resolveShopifyBlock(id);
    if (!block) return [];

    if (block.hasAttribute('data-hide')) return [block];

    var selfPanel = block.querySelector('[data-hide][data-cms-block-id="' + cssEscape(normalizeModalId(id)) + '"]');
    if (selfPanel) return [selfPanel];

    // content-card：切换其下所有带 data-hide 的内容区；父卡显隐由 CSS :has() 决定
    if (block.classList.contains('content-card')) {
      return Array.prototype.slice.call(block.querySelectorAll('[data-hide]'));
    }

    var panel = block.querySelector('[data-hide]');
    return panel ? [panel] : [];
  }

  function isDataHideHidden(el) {
    return el.getAttribute('data-hide') === 'true';
  }

  function setDataHide(el, hide) {
    if (!el) return;
    el.setAttribute('data-hide', hide ? 'true' : 'false');
  }

  /** Toggle data-hide on matched nodes for one id */
  function toggleCmsBlock(id) {
    const els = resolveHideEls(id);
    if (!els.length) return false;

    // 同 id 命中多个时：当前若有任一显示则全部隐藏，否则全部显示
    const anyVisible = els.some(function (el) {
      return !isDataHideHidden(el);
    });
    els.forEach(function (el) {
      setDataHide(el, anyVisible);
    });
    return true;
  }

  function showCmsBlock(id) {
    const els = resolveHideEls(id);
    if (!els.length) return false;
    els.forEach(function (el) {
      setDataHide(el, false);
    });
    return true;
  }

  function hideCmsBlock(id) {
    const els = resolveHideEls(id);
    if (!els.length) return false;
    els.forEach(function (el) {
      setDataHide(el, true);
    });
    return true;
  }

  function revealCmsBlock(id) {
    return showCmsBlock(id);
  }

  function showCmsById(id) {
    if (resolveModal(id)) return openModal(id);
    return showCmsBlock(id);
  }

  function toggleCmsById(id) {
    if (resolveModal(id)) return toggleModal(id);
    return toggleCmsBlock(id);
  }

  /** Toggle one or many ids (comma-separated) via data-hide / modal */
  function toggleCmsByIds(raw) {
    const ids = parseCmsIds(raw);
    let any = false;
    ids.forEach(function (id) {
      if (toggleCmsById(id)) any = true;
    });
    return any;
  }

  function showCmsByIds(raw) {
    const ids = parseCmsIds(raw);
    let any = false;
    ids.forEach(function (id) {
      if (showCmsById(id)) any = true;
    });
    return any;
  }

  window.cmsOpenModal = openModal;
  window.cmsCloseModal = closeModal;
  window.cmsCloseAllModals = closeAllModals;
  window.cmsRevealBlock = revealCmsBlock;
  window.cmsHideBlock = hideCmsBlock;
  window.cmsShowById = showCmsById;
  window.cmsShowByIds = showCmsByIds;
  window.cmsToggleById = toggleCmsById;
  window.cmsToggleByIds = toggleCmsByIds;

  function hideCmsPopupTarget(btn) {
    const selector = btn.getAttribute('data-cms-hide-selector');
    if (!selector) return;
    const el = btn.closest(selector);
    if (!el) return;
    el.style.display = 'none';
  }

  function invokeCmsClick(expr) {
    if (!expr) return;
    const trimmed = String(expr).trim();
    if (!trimmed) return;

    const match = trimmed.match(/^([a-zA-Z_$][\w$]*(?:\.[a-zA-Z_$][\w$]*)*)\s*(?:\((.*)\))?$/);
    if (!match) return;

    const path = match[1].split('.');
    let fn = window;
    for (let i = 0; i < path.length; i++) {
      fn = fn[path[i]];
      if (fn == null) return;
    }
    if (typeof fn !== 'function') return;

    const argsSource = match[2] == null ? '' : match[2].trim();
    if (!argsSource) {
      fn();
      return;
    }

    try {
      const args = Function('"use strict"; return [' + argsSource + '];')();
      fn.apply(null, args);
    } catch (err) {
      console.warn('[cms-btn] click_name invoke failed:', trimmed, err);
    }
  }

  function scrollCmsTabToCenter(trigger) {
    const nav = trigger.closest('.cms-content-tab__nav');
    if (!nav) return;
    if (nav.scrollWidth <= nav.clientWidth + 1) {
      nav.scrollLeft = 0;
      return;
    }

    const triggers = Array.prototype.slice.call(nav.querySelectorAll('[data-cms-tab-trigger]'));
    const index = triggers.indexOf(trigger);
    const navRect = nav.getBoundingClientRect();
    const btnRect = trigger.getBoundingClientRect();
    const maxLeft = Math.max(0, nav.scrollWidth - nav.clientWidth);
    let targetLeft;

    /* 首尾 Tab：贴齐可视区边缘，保证可拖到最左/最右看全 */
    if (index <= 0) {
      targetLeft = 0;
    } else if (index === triggers.length - 1) {
      targetLeft = maxLeft;
    } else {
      const btnCenter = btnRect.left - navRect.left + nav.scrollLeft + btnRect.width / 2;
      targetLeft = Math.max(0, Math.min(btnCenter - nav.clientWidth / 2, maxLeft));
    }

    if (typeof nav.scrollTo === 'function') {
      nav.scrollTo({ left: targetLeft, behavior: 'smooth' });
    } else {
      nav.scrollLeft = targetLeft;
    }
  }

  function getCmsTabTriggers(root) {
    const nav = root.querySelector('.cms-content-tab__nav');
    if (!nav) return [];
    return Array.prototype.slice.call(nav.querySelectorAll('[data-cms-tab-trigger]'));
  }

  /* 取整块内容区节点（外层 content-card_item），而非仅内层 panel */
  function getCmsTabPanels(root) {
    return Array.prototype.filter.call(root.children, function (el) {
      return el.querySelector('[data-cms-tab-panel]');
    });
  }

  function activateCmsTab(root, index) {
    const triggers = getCmsTabTriggers(root);
    const panels = getCmsTabPanels(root);
    if (!panels.length) return;

    const maxIndex = Math.max(triggers.length, panels.length) - 1;
    const safeIndex = Math.max(0, Math.min(index, maxIndex));

    triggers.forEach(function (btn, i) {
      const active = i === safeIndex;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    panels.forEach(function (panel, i) {
      const active = i === safeIndex;
      panel.classList.toggle('is-active', active);
      panel.removeAttribute('hidden');
      if (active) {
        panel.style.removeProperty('display');
      }
    });

    root.classList.add('cms-tabs-ready');
  }

  function switchCmsTab(trigger) {
    const root = trigger.closest('[data-cms-content-tab]');
    if (!root) return;

    const triggers = getCmsTabTriggers(root);
    const index = triggers.indexOf(trigger);
    if (index < 0) return;

    activateCmsTab(root, index);
    scrollCmsTabToCenter(trigger);
  }

  function initCmsTabState(scope) {
    const roots = (scope || document).querySelectorAll('[data-cms-content-tab]');
    roots.forEach(function (root) {
      const triggers = getCmsTabTriggers(root);
      const panels = getCmsTabPanels(root);
      if (!panels.length) return;

      let activeIndex = 0;
      for (let i = 0; i < triggers.length; i++) {
        if (triggers[i].hasAttribute('data-cms-tab-default')) {
          activeIndex = i;
          break;
        }
      }
      activateCmsTab(root, activeIndex);
      if (triggers[activeIndex]) scrollCmsTabToCenter(triggers[activeIndex]);
    });
  }

  document.addEventListener('click', function (e) {
    const cmsCloseBtn = e.target.closest('.cms-popup__close[data-cms-hide-selector]');
    if (cmsCloseBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      hideCmsPopupTarget(cmsCloseBtn);
      return;
    }

    const tabTrigger = e.target.closest('[data-cms-tab-trigger]');
    if (tabTrigger) {
      e.preventDefault();
      switchCmsTab(tabTrigger);
      return;
    }

    const clickTrigger = e.target.closest('[data-cms-click]');
    if (clickTrigger) {
      e.preventDefault();
      invokeCmsClick(clickTrigger.getAttribute('data-cms-click'));
      return;
    }

    const trigger = e.target.closest('[data-modal-trigger]');
    if (trigger) {
      toggleCmsByIds(trigger.dataset.modalTrigger);
      return;
    }

    const closeBtn = e.target.closest('[data-modal-close]');
    if (closeBtn) {
      closeModal(closeBtn.dataset.modalClose);
      return;
    }

    if (e.target.classList.contains('cms-modal-overlay')) {
      closeAllModals();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllModals();
  });

  function syncBodyOverflowForOpenModals() {
    document.body.style.overflow = document.querySelector('.cms-modal-overlay.is-open')
      ? 'hidden'
      : '';
  }

  function initCmsModals(scope) {
    initCmsTabState(scope);
    syncBodyOverflowForOpenModals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCmsModals();
    });
  } else {
    initCmsModals();
  }
  document.addEventListener('shopify:section:load', function (e) {
    initCmsModals(e.target);
  });

  /* 表格 / Tab 导航：鼠标拖动浏览（隐藏滚动条；触屏保留原生滑动） */
  (function initCmsDragScroll() {
    var DRAG_THRESHOLD = 4;
    var SCROLL_SELECTOR = '.cms-table-scroll, .cms-content-tab__nav';
    var active = null;

    function canScroll(el) {
      return el.scrollWidth > el.clientWidth + 1 || el.scrollHeight > el.clientHeight + 1;
    }

    function onPointerDown(e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      var scroller = e.target.closest(SCROLL_SELECTOR);
      if (!scroller || !canScroll(scroller)) return;
      /* 避开可点击控件，避免 Tab 按钮点击被拖动逻辑吞掉 */
      if (e.target.closest('a, button, input, textarea, select, [data-cms-click], [data-cms-tab-trigger], [data-modal-trigger]')) {
        return;
      }

      active = {
        el: scroller,
        pointerId: e.pointerId,
        startX: e.clientX,
        startY: e.clientY,
        scrollLeft: scroller.scrollLeft,
        scrollTop: scroller.scrollTop,
        dragging: false
      };
    }

    function onPointerMove(e) {
      if (!active || e.pointerId !== active.pointerId) return;
      var dx = e.clientX - active.startX;
      var dy = e.clientY - active.startY;

      if (!active.dragging) {
        if (Math.abs(dx) < DRAG_THRESHOLD && Math.abs(dy) < DRAG_THRESHOLD) return;
        active.dragging = true;
        active.el.classList.add('is-dragging');
        try {
          active.el.setPointerCapture(e.pointerId);
        } catch (err) {}
      }

      e.preventDefault();
      active.el.scrollLeft = active.scrollLeft - dx;
      active.el.scrollTop = active.scrollTop - dy;
    }

    function onPointerUp(e) {
      if (!active || e.pointerId !== active.pointerId) return;
      var wasDragging = active.dragging;
      var el = active.el;
      if (wasDragging) {
        el.classList.remove('is-dragging');
        el._cmsSuppressClick = true;
        setTimeout(function () {
          el._cmsSuppressClick = false;
        }, 0);
      }
      active = null;
    }

    document.addEventListener('pointerdown', onPointerDown, true);
    document.addEventListener('pointermove', onPointerMove, true);
    document.addEventListener('pointerup', onPointerUp, true);
    document.addEventListener('pointercancel', onPointerUp, true);
    document.addEventListener(
      'click',
      function (e) {
        var scroller = e.target.closest(SCROLL_SELECTOR);
        if (scroller && scroller._cmsSuppressClick) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  })();
})();
